// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2OeRu","content":"GlobalSearch_content__1fUtc"};